<template>
  <div>
    <v-img
      v-if="images.length <= 1"
      :aspect-ratio="16 / 9"
      :src="images?.[0]?.url"
    />

    <swiper-wrapper
      v-else-if="rerender"
      :autoplay="images.length > 1"
      wrapper-class="intro-slider"
    >
      <div
        v-for="(banner, index) in images"
        :key="index"
        class="swiper-slide"
        style="user-select: none"
        @click="pdfLoader(banner)"
      >
        <v-responsive :aspect-ratio="16 / 9">
          <v-card
            :class="{
              'hide-overlay':
                hideOverlay || !(!!banner.description || !!banner.title),
            }"
            :href="!!banner.link ? fixLink(banner.link) : ''"
            :style="{ backgroundImage: `url(${banner.url})` }"
            :tag="!!banner.link ? 'a' : 'div'"
            class="card-wrapper"
            flat
            target="_blank"
            width="100%"
          >
            <div class="page-content-wrapper col">
              <v-card class="mx-auto transparent" dark flat max-width="70%">
                <v-card-title
                  class="font-size-h3 text-break"
                  v-text="banner.title"
                />

                <pre
                  :style="{ fontSize: descResizer }"
                  class="col text-break"
                  v-text="banner.description"
                />
              </v-card>
            </div>
          </v-card>
        </v-responsive>
      </div>
    </swiper-wrapper>
  </div>
</template>

<script>
import SwiperWrapper from "../cm/swiperWrapper";

let swiper = null;

export default {
  name: "introSlider",

  components: { SwiperWrapper },

  props: {
    value: [Object, Array],
    isSlider: Boolean,
    type: {
      type: String,
      default: "banner",
    },
    hideOverlay: Boolean,
  },

  data: () => ({
    rerender: true,
    sliderData: [
    ],
  }),

  created() {
    this.$root.$on("rerenderSwiper", this.rerenderSwiper);
  },

  computed: {
    images() {
      if (this.isSlider) {
        return this.value ?? this.sliderData;
      } else {
        if (
          this.value?.[this.type]?.images &&
          this.value[this.type].images.length > 0
        ) {
          this.$watch(
            "value.banner",
            () => {
              this.rerender = false;
              this.$nextTick(() => {
                this.rerender = true;
              });
            },
            { deep: true },
          );

          return this.value[this.type].images;
        } else return this.sliderData;
      }
    },
    descResizer(val) {
      if (val.length > 100) return "7pt";
      else if (val.length > 200) {
        return "4pt";
      } else return "16px";
    },
  },

  watch: {
    value: {
      deep: true,

      handler(val) {
        // this.forceRerender = Date.now();
        this.rerenderSwiper();
      },
    },
  },

  methods: {
    pdfLoader(value) {
      if (this.type === "pdf") {
        window.open(value.link, "_blank");
      }
    },
    rerenderSwiper() {
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
      });
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
  color: unset;
}

.card-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}

.card-wrapper:not(.hide-overlay):before {
  content: "" !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: rgba(0, 0, 0, 0.7) !important;
  opacity: 1 !important;
}

.swiper-slide-active >>> .page-content-wrapper {
  animation: anim-in ease-in;
  animation-delay: 1s;
  animation-fill-mode: both;
  animation-duration: 1s;
}

@keyframes anim-in {
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
